import { css } from '@emotion/react';

export const icon = css`
  display: inline-block;
  border: 0;
`;

export const clickable = css`
  cursor: pointer;

  &:hover {
    background-color: var(--gray-80);
    border-radius: 4px;
  }
`;
